import { render, staticRenderFns } from "./CardBodyInfo.vue?vue&type=template&id=05695b20&scoped=true&"
import script from "./CardBodyInfo.vue?vue&type=script&lang=js&"
export * from "./CardBodyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05695b20",
  null
  
)

export default component.exports